export default __webpack_public_path__ + "static/media/fan-galleries3.33f90fc0.jpg";